module.exports = __webpack_public_path__ + "img/54.47f985e2.jpg";